<div class="new-communication gap-container">
  <app-display-large>{{ "Messages" | translate }}</app-display-large>
  <div class="content">
    <div class="new-thread" *ngIf="thread && message">
      <h3 class="subtitle">
        {{ "Sendamessageviachat" | translate }}
      </h3>

      <div style="width: 100%">
        <app-shared-form-input-text
          [(ngModel)]="thread!.subject"
          [disabled]="loading"
          id="subject"
          name="subject"
          i18n-label="@@NewCommNewSubject"
          label="{{ 'NewCommNewSubject' | translate }}"
          placeholder="{{ 'Eg.: What documents do I need' | translate }}"
          [maxlength]="SUBJECT_MAX_LENGTH"
          (ngModelChange)="onSubjectChange()"
        ></app-shared-form-input-text>

        <div
          class="character-counter"
          [ngClass]="{
            warning: thread.subject.length > SUBJECT_MAX_LENGTH * 0.8,
            error: thread.subject.length > SUBJECT_MAX_LENGTH
          }"
        >
          {{ thread.subject.length }}/{{ SUBJECT_MAX_LENGTH }}
        </div>

        <div *ngIf="subjectError" class="error-message">
          {{ subjectError | translate }}
        </div>
      </div>

      <div style="width: 100%">
        <app-shared-form-input-text
          [(ngModel)]="message!.value"
          id="value"
          [disabled]="loading"
          name="value"
          i18n-label="@@NewCommNewMessage"
          label="{{ 'NewCommNewMessage' | translate }}"
          placeholder="{{ 'Type your message' | translate }}"
          [maxlength]="MESSAGE_MAX_LENGTH"
          (ngModelChange)="onMessageChange()"
        ></app-shared-form-input-text>

        <div
          class="character-counter"
          [ngClass]="{
            warning: message.value.length > MESSAGE_MAX_LENGTH * 0.8,
            error: message.value.length > MESSAGE_MAX_LENGTH
          }"
        >
          {{ message.value.length }}/{{ MESSAGE_MAX_LENGTH }}
        </div>

        <div *ngIf="messageError" class="error-message">
          {{ messageError | translate }}
        </div>
      </div>

      <button
        class="submit-btn"
        (click)="saveThread()"
        [disabled]="loading || !isFormValid"
      >
        {{ (loading ? "Sending..." : "Send") | translate }}
      </button>
    </div>
    <div class="divider" *ngIf="email || phone">
      <span class="divider-line"></span>
      <span class="divider-text">{{ "or" | translate }}</span>
      <span class="divider-line"></span>
    </div>
    <div class="default-contacts">
      <h3 class="subtitle" *ngIf="email || phone">
        {{ "Chooseoneofthecontactmethodstosendamessage" | translate }}
      </h3>
      <div class="options" *ngIf="email || phone">
        <div class="option-item" *ngIf="email">
          <mat-icon>mail</mat-icon>
          <span class="option-type"
            ><span class="nowrap">E-mail:</span>
            <a
              title="{{ email }}"
              href="mailto:{{ email }}"
              class="option-value"
              >{{ email }}</a
            ></span
          >
        </div>
        <div class="option-item" *ngIf="phone">
          <mat-icon>phone</mat-icon>
          <span class="option-type"
            >{{ "Call" | translate }}:
            <!-- <img src="assets/img/eua-flag.svg" alt="" class="flag"  /> -->
            <span class="option-value"> {{ phone }}</span></span
          >
        </div>
      </div>
    </div>
  </div>
</div>
